export const FETCH_AGES = 'FETCH_AGES'
export const FETCH_AGES_SUCCESS = 'FETCH_AGES_SUCCESS'
export const FETCH_AGES_ERROR = 'FETCH_AGES_ERROR'

export const FETCH_REGISTRY = 'FETCH_REGISTRY'
export const FETCH_REGISTRY_SUCCESS = 'FETCH_REGISTRY_SUCCESS'
export const FETCH_REGISTRY_ERROR = 'FETCH_REGISTRY_ERROR'
